import { get } from '../../../Services/http';
import { catchError } from '../../../Actions/Error.action';

export const TIME_LINE_BLOCK_RECEIVE = 'TIME_LINE_BLOCK_RECEIVE';
export const TIME_LINE_BLOCK_ERROR = 'TIME_LINE_BLOCK_ERROR';

export const fetchTimeLineModel = (id) => (dispatch) => {
    return get('/api/timeLineBlock/' + id)
        .then((response) => response.json())
        .then((result) => dispatch(receive(result)))
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const receive = (result) => ({
    type: TIME_LINE_BLOCK_RECEIVE,
    payload: result,
});

export const setError = (error) => ({
    type: TIME_LINE_BLOCK_ERROR,
    payload: {
        error,
    },
});
